import Glide from "@glidejs/glide"

export default class GalleryModal {
    constructor(slickOptions, galleryModalSelector) {
        this.glide = null;
        this.genericSliderId = null;
        this.mainImage = null;
        this.modalEl = document.querySelector(galleryModalSelector);
        if(!this.modalEl) {
            return
        }
        this.activeSlideCounter = this.modalEl.querySelector('.js-gallery-active-slide');
        this.zoomOffsetX = 0;
        this.zoomOffsetY = 0;
        this.classes = {
            thumbnailActive: 'thumb-active',
            zoomActive: 'zoom-active'
        }
        this.selectors = {
            glide: '.js-gallery-glider',
            thumbnail: '.js-gallery-thumbnail',
            thumbnailActive: `.${this.classes.thumbnailActive}`,
            zoom: '.js-image-zoom',
            zoomActive: `.${this.classes.zoomActive}`
        }

        this.modalEl.addEventListener('shown.bs.modal', (e) => {
            window.pauseAllMedia()
            const slideId = this.getSlideId(e.relatedTarget);
            if (!this.glide) {
                this.initGlide(slickOptions, slideId);
            }
            else {
                this.glide.go(`=${slideId}`);
                this.activeSlideCounter.textContent = slideId;
            }

            this.setNavigationItemActive(slideId);
        });

        this.modalEl.addEventListener('click', (event) => {
            const slideNavItem = event.target.closest(this.selectors.thumbnail);
            if (slideNavItem && this.glide) {
                const slideId = this.getSlideId(slideNavItem);
                this.setNavigationItemActive(slideId);
                this.glide.go(`=${slideId}`);
            }

            if(window.use_zoom_in_gallery && window.innerWidth >= SBBreakpoints.LG) {
                const zoomEl = event.target.closest(this.selectors.zoom);
                if(zoomEl && this.glide) {
                    this.zoomToggle(zoomEl);
                }
            }
        });

        this.modalEl.addEventListener('hidden.bs.modal', (event) => {
            window.pauseAllMedia()
            const activeZoom = this.modalEl.querySelector(`${this.selectors.zoom}${this.selectors.zoomActive}`);
            if(activeZoom) {
                activeZoom.classList.toggle(this.classes.zoomActive);
                activeZoom.removeEventListener('mousemove', this.zoom);
            }

            if (window.glideInstances[this.genericSliderId]) {
                setTimeout(() => {
                    window.glideInstances[this.genericSliderId].destroy()
                    delete window.glideInstances[this.genericSliderId]
                    this.glide = null
                }, 300)
            }
        });
    }

    getSlideId(el) {
        let slideId = 0;
        if (el.dataset.hasOwnProperty('slideId')) {
            slideId = el.dataset['slideId'];
        }
        return slideId;
    }

    initGlide(slickOptions, slideId) {
        const glideEl = this.modalEl.querySelector(this.selectors.glide)
        this.genericSliderId = glideEl.dataset.genericSlider;
        this.glide = new Glide(glideEl, {
            ...slickOptions,
            startAt: slideId
        });
        this.activeSlideCounter.textContent = parseInt(slideId, 10)+1;
        this.glide.on('run.after', (e) => {
            this.setNavigationItemActive(this.glide.index);
            this.activeSlideCounter.textContent = (this.glide.index + 1);
            this.modalEl
                .querySelector(`${this.selectors.zoom}${this.selectors.zoomActive}`)?.classList
                .remove(this.classes.zoomActive);
        });
        this.glide.mount();

        const event = new CustomEvent('glide-initialized', {detail: this.glide})
        document.body.dispatchEvent(event)

        this.glide.on('run.after', () => {
            window.pauseAllMedia()
        })

        window.glideInstances = window.glideInstances || {};
        window.glideInstances[glideEl.dataset['genericSlider']] = this.glide;
    }

    setNavigationItemActive(slideId) {
        this.modalEl
            .querySelector(`${this.selectors.thumbnail}${this.selectors.thumbnailActive}`)?.classList
            .remove(this.classes.thumbnailActive);
        this.modalEl
            .querySelector(`${this.selectors.thumbnail}[data-slide-id="${slideId}"]`)?.classList
            .add(this.classes.thumbnailActive);
    }

    zoomToggle(zoomEl) {
        zoomEl.classList.toggle(this.classes.zoomActive);
        if (zoomEl.classList.contains(this.classes.zoomActive)) {
            zoomEl.addEventListener('mousemove', this.zoom.bind(this));
        }
        else {
            zoomEl.removeEventListener('mousemove', this.zoom.bind(this));
        }
    }

    zoom(e) {
        const zoomer = e.currentTarget;
        if (e.offsetX !== undefined) {
            this.zoomOffsetX = e.offsetX;
        }
        if (e.offsetY !== undefined) {
            this.zoomOffsetY = e.offsetY;
        }
        const x = this.zoomOffsetX / zoomer.offsetWidth * 100;
        const y = this.zoomOffsetY / zoomer.offsetHeight * 100;
        zoomer.style.backgroundPosition = `${x}% ${y}%`;
    }
}

